/* eslint-disable max-len */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: ()=>_default
});
const lang = {
    passkey_prompt: {
        title: "Create a Passkey",
        description: "Sign in to your account easily and securely with a passkey. Note: Your biometric data is only stored on your devices and will never be shared with anyone.",
        button: "Create a Passkey",
        remind_later: "Remind me later"
    },
    authTemplate: {
        welcome: 'Welcome to {0}',
        log_in: 'Log in'
    },
    footerTemplate: {
        message_disclaimer: 'Message frequency may vary. Message & Data Rates May apply. Want to unsubscribe? Reply STOP to your text message. Need help? Reply HELP to your text message. No customer information is transmitted or shared through these text message notifications. No mobile information will be shared with third parties for marketing purposes.',
        privacy_policy: 'Privacy Policy',
        terms_conditions: 'Terms and Conditions'
    },
    loginTemplate: {
        enter_code_title: 'Enter Code',
        enter_code_subtitle: 'Enter your {0}-digit verification code below',
        or_separator: 'or',
        no_phone_number_message: 'Click the button to receive your verification code',
        phone_number_message: 'We sent a verification code to {0}. Please enter the code above.',
        resend_code_cta: 'Send me a verification code',
        resend_code_countdown: 'Resend code...{0}',
        resend_code: 'Resend code'
    },
    sharedPin: {
        errors: {
            invalidCode: 'You must enter a valid code.'
        },
        create: {
            title: 'Request a Verification Code',
            description: 'Click the button below to request a one-time, 6-digit verification code to continue.',
            button: 'Send me a verification code'
        }
    },
    ten_dlc: {
        create: {
            title: 'Create Your Verification Code',
            description: 'To enhance your security, please create a 4-digit verification code. You’ll use this code for future logins.',
            labels: {
                createPin: 'Create PIN',
                confirmPin: 'Confirm PIN'
            },
            submit: 'Create PIN',
            errors: {
                codeRequired: 'Code is required.',
                confirmCodeRequired: 'Confirming code is required.',
                invalidCodeFormat: 'Invalid code format.',
                codesMustMatch: 'Codes must match.'
            }
        },
        welcome: {
            title: 'Welcome back, {0}!',
            title_anonymous: 'Welcome!',
            description: 'Your message is just one click away. Stay updated and never miss an important notification!',
            view_message: 'Continue'
        }
    },
    common: {
        fetching: 'Fetching...',
        refresh: 'Refresh',
        refresh_success: 'Refresh Success',
        refreshed: 'Refreshed',
        rewards_placeholder_title: 'No Rewards Available',
        rewards_placeholder_subtitle: 'You don’t have any rewards available at this time, please refresh or check again later',
        offers_placeholder_title: 'No Offers Available',
        offers_placeholder_subtitle: 'You don’t have any offers at this time, please refresh or check again later',
        milestones_placeholder_title: 'No Milestones Available',
        milestones_placeholder_subtitle: 'You don’t have any milestones to unlock at this time, please refresh or check again later',
        messages_placeholder_title: 'No New Messages',
        messages_placeholder_subtitle: 'You don’t have any new messages at this time, please refresh or check again later',
        purchases_placeholder_title: 'No Purchase History',
        purchases_placeholder_subtitle: 'Check again after your next shopping trip! or click refresh',
        redemptions_placeholder_title: 'No Redemption History',
        redemptions_placeholder_subtitle: 'Check again after your first redemption! or click refresh'
    },
    validation: {
        email_required: 'email is required',
        email_invalid: 'invalid email format',
        code_required: 'code is required',
        code_invalid: 'invalid code format',
        name_required: 'name is required',
        name_long: 'name is too long',
        name_invalid: 'invalid name format',
        number_required: 'card number is required',
        number_short: 'card number is too short',
        number_long: 'card number is too long',
        number_invalid: 'invalid card number format',
        zip_required: 'zip code is required',
        zip_invalid: 'invalid zip code format',
        cvv_required: 'CVV is required',
        cvv_invalid: 'invalid CVV format',
        expiry_required: 'expiry is required',
        expiry_invalid: 'invalid date'
    },
    auth: {
        ten_dlc: {
            four_pin: {
                title: 'Welcome to {0}!',
                description: 'Click the button to receive your verification code.'
            },
            six_pin: {
                title: 'Welcome to {0}!',
                description: 'Click the button to receive your verification code.'
            },
            birthday: {
                title: 'Confirm Your Identity',
                description: 'Please select your birthday from the options below in order to continue',
                verify: 'Verify Birthday',
                error: 'The birthday you selected does not match the birthday on your profile, please try again',
                confirm: 'Confirm birthday'
            },
            welcome: {
                title: 'Welcome, {0}',
                title_anonymous: 'Welcome',
                description: 'Your message is just a click away.',
                description_two: 'Stay updated and never miss an important notification.'
            },
            create: {
                title: 'Create your PIN code',
                description: 'To enhance your security, please create a 4-digit PIN code. You\'ll use this PIN for future logins',
                create_pin: 'Create pin',
                confirm_pin: 'Confirm Pin',
                submit_pin: 'Submit'
            },
            login: {
                title: 'Log in',
                description: 'Welcome back! Please enter your 4-digit PIN to access your messages.',
                enter_pin: 'Enter pin',
                submit_pin: 'Login',
                forgot_pin: 'Forgot your PIN?',
                send_pin: 'Send me my PIN'
            },
            enter_code: 'Enter code',
            forgot_code: 'Forgot your code?',
            view_message: 'View message',
            see_menu: 'See menu',
            dismiss: 'Close'
        },
        validation: {
            phone_number_required: 'Phone number is required',
            pin_required: 'Pin is required',
            pin_pattern: 'Pin must be at least 4 characters long',
            email_required: 'Email is required',
            email_pattern: 'Invalid email',
            password_required: 'Password is required',
            password_pattern: 'Password must be at least 8 characters long, 1 letter, 1 number, and 1 punctuation',
            confirm_required: 'Confirmation is required',
            confirm_validate: 'Password must match',
            shared_pin_paragraph: 'Click the button to receive your verification code',
            forgot_code: 'Forgot code?',
            send_me_my_login_code: 'Send me my log in code'
        },
        links: {
            register: 'Need an Account?',
            forgot: 'Forgot Password?',
            login: 'Already Have an Account?'
        },
        confirm_account: {
            error_title: 'Oh No!',
            error_paragraph: 'There was an error with your confirmation link. Please check your email and try again.',
            confirmed_title: 'Account Confirmed!',
            confirmed_paragraph: 'You may now login with your email start setting up your business!',
            confirming: 'Confirming Account...'
        },
        forgot_password: {
            success_title: 'Success!',
            success_paragraph: 'Check your email for a password reset link.',
            title: 'Forgot Password'
        },
        reset_password: {
            validating_token: 'Validating token...',
            invalid_link: 'Invalid password reset link...',
            success_title: 'Success!',
            success_paragraph: 'You may now login with your new password.',
            title: 'Reset Password'
        },
        login: {
            title: 'Hello, <br/>welcome back!',
            paragraph: 'Enter your phone number',
            success: 'Login Successful!',
            pin_paragraph: 'A temporary pin has been sent to your phone and email (if applicable) - please enter it below to proceed'
        },
        location: {
            what_state: 'What {0} {1} are you located in?',
            choose_state: 'Please select a state',
            cannot_continue: 'Cannot Continue',
            merchant_does_not_serve: 'Sorry! This merchant is not authorized to provide service in your particular state.',
            location_associated_paragraph: 'Select your store program',
            location_unassociated_paragraph: 'Traveling? Click below to register for our other state programs'
        },
        logout: 'You have logged out!',
        register: {
            title: 'Welcome to {0}!',
            paragraph: 'By providing your phone number and checking the box provided, you consent to receive marketing focused text messages and calls, including via an automatic telephone dialing system or prerecorded or artificial voice from {0} and its affiliates, brands and product manufacturers. Consent is not required as a condition of purchasing any goods or services. Standard per minute call and message rates may apply. Opt out at any time by replying "END".'
        },
        update_password: {
            title: 'Update Password',
            paragraph: 'A temporary password has been set on your account. For security reasons, you cannot continue until you set a new password. Please set your new password and you will be able to login again.'
        },
        geofence: {
            title: 'Geo-Restriction',
            default_subtitle: 'Due to app store policy, this app can only be used in states/provinces where our stores are located. Share your location to continue',
            out_of_state_subtitle: 'Sorry. We don’t provide services in your area: {0}. Due to app store policy, you will not be able to access the app until you are in the same state/province as our stores',
            out_of_state_manually_subtitle: 'Sorry. We don’t provide services in your area: {0}. Please select your state manually if you think that is a mistake.',
            blocked_or_denied_subtitle: 'Location permissions are required in order to proceed',
            grant_permissions: 'Grant Permissions'
        }
    },
    alerts: {
        loyalty_opt_in: 'Opt in to loyalty',
        loyalty_opt_in_message: 'You are currently not opted in to our rewards program by providing your signature below and clicking "opt in" you will now be eligible to earn loyalty points and redeem rewards.',
        text_opt_in: 'Wait',
        text_opt_in_message: 'You did not sign up to receive  text about specials deals and offers. Go back and check the check box in the terms and conditions to enroll into text marketing!',
        text_opt_in_message2: 'Are you sure you want to join without hearing about specials deals and offers?',
        hipaa_opt_in_message: 'The following information is required to complete sign up… check the box for HIPAA',
        meta_message: 'The following information is required to complete sign up…',
        interest_auto_connect: 'Please click on your interests to activate the offer'
    },
    rewards: {
        title: 'Rewards',
        modal_title: 'Redeem Reward',
        title_points_rewards: '{0} point rewards',
        points_redeemable: 'Points redeemable',
        spend_toward_status: 'Spend towards status',
        redemption_text: 'STOP! Please make sure you are with staff BEFORE redeeming your reward. Staff needs to watch you redeem in order for you to receive your reward.\nAre you ready to redeem your reward: {0}',
        redemption_modal_title: 'Reward Redemption',
        redemption_in_store: 'So excited you want to redeem your points! Please redeem your points at the store and prior to check out!',
        available_points: 'available points',
        click_here_to_earn: 'click here to start earning points',
        expires_at: 'expires {0}',
        return_to: 'Return to {0}'
    },
    redeem: {
        at: 'Redeemed at: {0}',
        valid_until: 'Valid until {0}',
        confirmation: 'Confirmation: {0}',
        confirmation_number: 'Confirmation: {0}',
        go_back: 'Return to wallet',
        expired: 'Expired!',
        expires: 'Expires',
        redeemed: 'Redeemed',
        redeemed_at: 'Redeemed at: {0}',
        back: 'Return to wallet',
        with_staff: 'I\'m with staff: proceed to {0}',
        points_needed: 'You need ',
        to_redeem: ' to redeem {0}',
        point: 'point',
        points: 'points'
    },
    offers: {
        title: 'Offers',
        title_refer: 'Refer a friend',
        modal_title: 'Redeem Offer',
        available_offers: 'Available offers',
        refer_friend: 'Refer a friend',
        redemption_text: 'STOP! Please make sure you are with staff BEFORE redeeming your reward. Staff needs to watch you redeem in order for you to receive your reward.\nAre you ready to redeem your reward: {0}',
        redemption_modal_title: 'Reward Redemption',
        redemption_in_store: 'So excited you want to redeem your offer! Please redeem your offer at the store and prior to check out!',
        unlock: 'Unlock this offer',
        add: 'Add',
        add_birthday: 'Add Birthday',
        free_pre_roll: '+ free pre-roll',
        desirable_action: 'Update your {0} to earn {1}',
        no_offers: 'No offers available',
        quantity: 'use {0}x'
    },
    milestones: {
        title: 'Milestones',
        spends_remaining: 'Spend {0} more to unlock {1}',
        spends_title: 'Spend {0} at {1} to earn {2}',
        points_remaining: 'Spend {0} more to unlock {1}',
        points_title: 'Spend {0} at {1} to earn {2}',
        benefits_title: 'Benefits include:',
        milestone_achieved: 'milestone achieved!',
        congratulations: 'Congratulations! You have achieved {0}',
        achieved: '{0} achieved!'
    },
    subscriptions: {
        no_plan_message: 'No premium plans available',
        title: 'Subscriptions',
        get: 'Subscribe',
        enjoying: 'Manage plan',
        active_section: 'Active plans',
        explore_section: 'Explore plans',
        back_button: 'Back to wallet',
        benefits: 'Benefits include',
        cancellation_warning: 'Are you sure you would like to cancel your subscription?',
        cancellation_disclaimer: 'By doing so, you will keep your benefits for the remainder of your current subscription period.',
        free_trial: 'The first {0} days are on us, then after that it\'s just ',
        free_then: '{0} days free, then ',
        active_until: 'Active until {0}',
        renews_on: 'Plan renews on {0}',
        update_email_info: 'Update your email information',
        billing: {
            both: '${0} a month or ${1} a year',
            monthly: '${0} a month',
            yearly: '${0} a year'
        },
        previously_used: 'previously used',
        pricing_title: 'Pricing',
        pricing: ', you can cancel any time you\'d like',
        email_verification: 'Verify your email to receive exclusive deals!',
        terms_prefix: 'I have read and agree to the ',
        terms_suffix: 'terms and conditions*',
        terms_error: 'You need to agree to the terms & conditions',
        next: 'Next (2 of 2)',
        email_field: 'email',
        email_error: 'There was an issue with your request: {0}. If the issue persists, please contact an administrator',
        details: {
            title: 'Unlock premium perks now!',
            description: 'Upgrade to our premium plan now and watch your savings grow. Don\'t miss out on exclusive perks and unbeatable rewards!',
            try_button: 'Continue',
            try_free_button: 'Try it free!'
        },
        code_sent: '1 code has been sent to your email inbox',
        code_field: 'code',
        code_resend: 'Resend code',
        change_email: 'Change email',
        verify_email: 'Verify email',
        manage: {
            title: 'Manage {0}',
            update_email: 'Update email',
            change_card: 'Change card',
            cancel_subscription: 'Cancel subscription'
        },
        success: {
            title: 'Welcome to {0}!',
            description: 'You have successfully subscribed to our {0}',
            description_two: 'Be on the look out for exclusive offers and promotions!',
            view_offers_button: 'View offers'
        },
        popups: {
            failed_payment: {
                title: 'Payment failed',
                text: 'To keep premium, update your payment method ASAP',
                button: 'Update'
            },
            sub_prompt: {
                title: 'Join our VIP club for exclusive offers',
                button: 'Click here to learn more',
                dismiss: 'Don\'t remind me'
            }
        }
    },
    credit_card: {
        add_payment: 'Add payment',
        choose_plan: 'Choose your plan',
        monthly_title: 'Monthly',
        monthly_price: '${0}/month',
        monthly_summary: 'Pay ${0} per month. Cancel anytime.',
        yearly_title: 'Yearly',
        yearly_price: '${0}/year',
        yearly_summary: 'Pay ${0} per year. Cancel anytime.',
        free_trial: '{0} day free trial',
        add_card: 'Add card information',
        name: 'cardholder name',
        number: 'card number',
        cvv: 'CVV',
        expiry: 'expiry',
        zip_code: 'zip code',
        subscribe_button: 'Subscribe',
        cancel_button: 'Cancel',
        disclaimer: 'By adding this card, you confirm that you are the cardholder or have authorization to use this payment method.'
    },
    profile: {
        title: 'Profile',
        my_account: 'My Account',
        phone: 'My Phone:',
        email: 'My Email:',
        birthday: 'My Birthday:',
        greetings: 'Hello, {0}',
        spend_toward_status: '{0} Spend towards status',
        upload_profile: 'Upload Profile Image',
        choose_from_library: 'Choose from library',
        take_photo: 'Take a photo',
        cancel: 'Cancel',
        edit: 'Edit',
        remove_photo: 'Remove Photo',
        profile_image_added: 'Profile image added.',
        profile_image_removed: 'Profile image removed.',
        profile_updated: 'Profile updated successfully!',
        undo: 'Undo'
    },
    profileMenu: {
        my_information: 'My Information',
        recent_history: 'Recent History',
        message_notifications: 'Message and Notification Settings',
        terms_condition: 'Terms and Condition',
        privacy_policy: 'Privacy Policy',
        leave_us_a_review: 'Leave us a Review',
        review_info: 'We’d love to hear what you think! Your feedback helps us grow and improve, so please take a moment to leave us a review. We’re excited to hear about your experience!'
    },
    leaveAReviewBanner: {
        title: 'We\'d love to hear from you',
        subTitle: 'Please, take a moment to leave us a review',
        buttonText: 'Leave us a Review'
    },
    accountInformation: {
        delete_account_title: 'Are you sure you want to delete your account?',
        delete_account_message: `By doing so, all of your earned loyalty points will be deleted and not available for your use and you will be opted out of receiving all messages from this retailer.

        Once you delete your account, this will be permanent and can't be undone.`,
        delete_account: 'Delete Account',
        delete_account_header_title: 'A temporary pin code has been sent to your phone. Enter it below to confirm that you want to delete your account.'
    },
    refer: {
        title: 'Refer a friend',
        copy_link: 'Copy Link',
        link_copied: 'Link Copied',
        text_prize: 'When one of your friends joins, on your referral, you will receive a',
        text_prize_purchase: 'When one of your friends spends {0} on your referral, you will receive a',
        prize: '30% off one purchase',
        text_receiver: 'and they will receive',
        pre_rolled_reward: 'a free pre-roll',
        text_link: 'Copy and share the link below with your friends or show your friends your unique qr code above for an easy sign up.',
        text_social_media: 'Do not forget to share your link on social media!'
    },
    interests: {
        title: 'Interests'
    },
    messages: {
        title: 'Message Center',
        no_messages: 'No Messages',
        shop_now: 'shop now'
    },
    anylink: {
        view_more: 'View more',
        view_offers: 'View offers',
        view_rewards: 'View rewards',
        view_profile: 'View profile',
        view_info: 'View my information',
        view_interests: 'View interests',
        view_refer: 'View refer link',
        shop_online: 'Shop online',
        view_gift_card: 'View {0}'
    },
    settings: {
        header_title: 'Communication settings',
        communication_preferences: 'Communication preferences',
        my_preferred: 'My preferred communication is ',
        modal_title: 'Opt in to email marketing',
        modal_paragraph: 'Agree to terms {0}and check the box below to opt in to the {1}',
        modal_terms_and_conditions: 'By completing this sing-up form and participating in our Program, you consent to our {0}',
        sms_opt_in_disclaimer: 'By selecting this box, I consent to receive informational and marketing calls and text messages from {0} and its subsidiaries, including sent by automated or prerecorded means, to the number provided. Consent is not a condition of purchase. Reply STOP to unsubscribe. Message and data rates may apply. See terms and privacy policy for additional information.',
        email_opt_in_disclaimer: 'By selecting this box, I consent to receive informational and marketing emails from {0} and its affiliates, including sent by automated or prerecorded means, to the email address provided. Consent is not a condition of purchase. See terms and privacy policy for additional information.',
        loyalty_opt_in_disclaimer: '',
        text_message: 'Text messages',
        push_notifications: 'Push notifications',
        email_notifications: 'Email notifications'
    },
    history: {
        title_purchases: 'Purchases',
        title_redemptions: 'Redemptions',
        transaction_total: 'Transaction total',
        item_ordered: 'Items ordered',
        category: 'Category',
        brand: 'Brand',
        product_name: 'Product name',
        redeemed: 'redeemed',
        points: 'points'
    },
    general: {
        accept: 'Accept',
        address1: 'Address 1',
        address2: 'Address 2',
        back: 'Back',
        birthday: 'Birthday',
        cancel: 'Cancel',
        cart: 'Cart',
        city: 'City',
        confirm_password: 'Confirm Password',
        continue: 'Continue',
        delete: 'Delete',
        edit: 'Edit',
        email: 'Email',
        female: 'Female',
        first_name: 'First Name',
        gender: 'Gender',
        get: 'Get',
        use: 'Use',
        earning: 'Earning',
        unlimited: 'unlimited',
        go_back: 'Go Back',
        last_name: 'Last Name',
        loading: 'Loading',
        login: 'Login',
        male: 'Male',
        merchant: 'Merchant',
        messages: 'Message Center',
        new_password: 'New Password',
        offers: 'Offers',
        old_password: 'Old Password',
        other: 'Other',
        password: 'Password',
        phone_number: 'Phone Number',
        pin: 'Enter code',
        press_to_sign: 'Press to sign',
        privacy_policy: 'Privacy Policy',
        profile: 'Profile',
        redeemed: 'Redeemed',
        region: 'State/Region',
        rewards: 'Rewards',
        save: 'Save',
        select_date: 'Select date',
        sign_below: 'Please sign below',
        signature_saved: 'Signature saved',
        signature: 'Signature',
        submit: 'Submit',
        success: 'Success',
        terms_and_conditions: 'Terms and Conditions',
        zip: 'Zip/Postal code',
        select_language: 'Select Language',
        preferred_method: 'Preferred Communication Method',
        add: 'add',
        interest: 'interest',
        update: 'update',
        updated: 'updated',
        email_example: 'john@gmail.com',
        how_did_you_hear_about_us: 'How did you hear about us',
        favorite_location: 'Favorite Location',
        wallet_terms: 'Terms and Conditions',
        submitError: 'There was some issue proceeding your request, please try again later',
        amount: 'amount',
        payment: 'payment',
        location: 'location',
        points: 'points',
        send: 'send',
        enabled: 'enabled',
        disabled: 'disabled',
        download_app: 'Download'
    },
    errors: {
        invalid_email: 'Please enter a valid email',
        birthday_in_past: 'Please select a date in past'
    },
    cart: {
        no_website: 'No website available'
    },
    apiErrors: {
        postJoinPhone: 'Error submitting phone number',
        getJoinPin: 'Error submitting pin',
        getWalletMember: 'Error receiving wallet',
        getWalletMilestones: 'Error receiving milestones',
        postWalletRedemption: 'Error redeeming rewards',
        getNativeMerchantOrgs: 'Error receiving locations',
        getNativeAppStashboardKeys: 'Error receiving message keys',
        getNativeAppStashboard: 'Error receiving message information',
        getNativeAppRewardRedemption: 'Error redeeming rewards',
        getNativeAppVisit: 'Error receiving visit',
        putNativeAppSync: 'Error syncing',
        patchNativeAppUpdate: 'Error updating your member',
        postNativeAppCreate: 'Error creating your member'
    },
    navigation: {
        menu: 'Menu',
        cart: 'Cart',
        messages: 'Messages',
        profile: 'Profile',
        rewards: 'Rewards',
        offers: 'Offers',
        refer: 'Refer',
        milestones: 'Milestones',
        subscriptions: 'Subscriptions',
        select_store: 'Select Store',
        springbigpay: 'Pay',
        premium: 'Premium',
        accountHistory: 'Purchase History',
        home: 'Home'
    },
    giftCard: {
        confirmation_modal: {
            complete: 'Gift card load complete!'
        },
        field: {
            amount: 'amount',
            method: 'payment method',
            loyalty: 'select loyalty card'
        },
        manage: {
            success: 'Payment information successfully removed',
            error: 'There was an error while deleting your payment information, please contact an administrator'
        },
        more_info: 'more info',
        fund_with_points: 'fund {0} with points',
        points_for: 'points for',
        select_card: 'select {0}',
        add_cc: 'Add credit/debit',
        cards: 'cards',
        plus_payment: '+ payment',
        other: 'other',
        manage_funds: 'manage funds',
        reloadable: 'reloadable',
        non_reloadable: 'non-reloadable',
        on: 'on',
        off: 'off',
        locations: 'Locations',
        used_at: 'Can be used at:',
        no_access: 'No access',
        claimBefore: 'Claim by {0}',
        claimNow: 'Claim Now',
        claim: 'Claim',
        claiming: 'claiming...',
        claimEmailVerifyHeader: 'Please verify your email to claim your {0}',
        claimSuccess: '{0} claimed!',
        bannerHeading: 'New {0}s Are Waiting For You',
        inboxHeading: '{0}s Available',
        inboxEmailNotValidatedHeading: 'Verify Your Email To Claim Your {0}s',
        inboxGrantsAvailable: 'You have unclaimed {0}s that require your attention.',
        claimBeforeExpiration: 'Claim them before they expire!',
        claimExtraNote: 'Note: {0}s must be claimed to be issued to your account.',
        inboxGrantsClaimed: '{0}s Added To Your Wallet',
        balanceUpdated: 'Your {0} balance has been updated!',
        description: '{0} {1}',
        addedOn: 'added {0}',
        navigateTo: 'Go to {0}s',
        inboxSendCodeButton: 'Send Code',
        inboxBannerHeading: 'New {0}s Are Waiting For You',
        inboxBannerSubHeading: 'You have {0} activity in your account',
        inboxBannerButton: 'Review Now',
        totalCards: 'Total cards',
        noCards: 'No cards available',
        addCash: 'Add cash funds',
        pinCode: 'pin code: {0}',
        sendToFriend: 'Send a {0} to a friend',
        importExistingButton: 'Import existing {0}',
        emailVerificationTitle: 'Please verify your email. It helps keep things secure!',
        nameCompletionFormTitle: 'Complete your profile to continue',
        nameComfirmTitle: 'Confirm your information in order to continue',
        primary: {
            title: 'primary card',
            button: 'make primary'
        },
        barcode: {
            view: 'view barcode'
        },
        update: {
            success: 'Successfully updated card',
            error: 'There was some issue updating this card to primary card, please try again later.'
        },
        balance: {
            manage_cash: 'Manage cash',
            cash_balance: 'Cash balance',
            point_balance: 'Point balance',
            convert_points_cash: 'Convert points to cash'
        },
        autoReload: {
            updateStatus: 'Auto-Reload'
        },
        confirm_points: {
            confirm_conversion: 'Confirm conversion',
            review_the_redemption: 'Review the redemption details related to loading your gift card',
            total_points: 'Total points',
            total_load_amount: 'Total load amount',
            payment_method: 'Payment method: ',
            points_conversion: 'Points conversion',
            points_per: '@ {0} points per $1',
            complete_conversion: 'Complete conversion'
        },
        addFunds: {
            fundWithPoints: 'Fund {0} with points',
            reloadSuccess: 'Reloaded card successfully',
            createSuccess: 'Created and loaded your card successfully',
            title: 'Add funds',
            autoReload: {
                title: 'Auto-reload settings',
                subTitle: 'Auto-reload',
                belowbalance: 'When balance is below',
                amount: 'Load amount',
                payment: 'Payment method'
            },
            conditions: {
                fees: '* an additional {0} processing fee will be added'
            },
            confirmation: {
                confirm_payment: 'Confirm payment',
                review_transaction_details: 'Review the transaction details related to loading your gift card',
                load_amount: 'Load amount',
                fee: 'Fee',
                total_amount: 'Total amount',
                payment_method: 'Payment method: ',
                charges: 'Charges will display on your statement from',
                important_payment_notice: 'Important Payment Notice',
                by_using_this_card: 'By using this card, you confirm that you are the cardholder or have authorization to use this payment method.',
                all_payments: 'All payments are final. Once confirmed, you cannot dispute or reverse them.',
                fraudulent: 'Fraudulent activity is illegal. It can result in:',
                legal_penalties: '• Legal penalties: Fines, imprisonment, or both.',
                account_closure: '• Account closure: Your wallet may be permanently closed.',
                credit_damage: '• Credit damage: Your credit score may be negatively impacted.',
                i_acknowledge: 'I acknowledge',
                complete_payment: 'Complete payment',
                please_acknowledge: 'Please acknowledge in order to proceed with payment'
            }
        },
        addPayment: {
            addBank: {
                caption: 'Connect to bank account',
                form: {
                    name: {
                        title: 'Bank account name *',
                        error: 'Account number is required and should be in a valid format'
                    },
                    number: {
                        title: 'Account number *',
                        error: 'Bank account name is required'
                    },
                    routingNumber: {
                        title: 'Routing number *',
                        error: 'Routing number is required and should be in a valid format'
                    }
                }
            },
            addCard: {
                caption: 'Credit/debit card',
                form: {
                    name: {
                        title: 'name on card *',
                        error: 'Name on card is required and should not contain any special characters or numbers'
                    },
                    number: {
                        title: 'card number*',
                        error: 'Card number is required and should be between 14 and 19 digits'
                    },
                    cvv: {
                        title: 'cvv*',
                        error: 'cvv is required and should be 3 digits'
                    },
                    expiryDate: {
                        title: 'expiry date*',
                        error: 'Expiry date is required and should be in the format mm/yy'
                    },
                    zip: {
                        title: 'zip*',
                        error: 'Zip is required and should be a mixture of 6 alphabets or numbers'
                    }
                }
            }
        },
        restrictions: {
            points_limit: 'Your current individual reload threshold for this period is {0} and up to {1} overall',
            cash_limit: 'Your current individual reload threshold for this period is ${0} and up to ${1} overall',
            one_time_point_limit_under: 'Your reload threshold for this period is {0} out of {1}',
            one_time_dollar_limit_under: 'Your reload threshold for this period is ${0} out of ${1}',
            one_time_point_limit_over: 'Your individual reload threshold for this period is {0}. Your overall remaining reload for this period is {1} out of {2}',
            one_time_dollar_limit_over: 'Your individual reload threshold for this period is ${0}. Your overall remaining reload for this period is ${1} out of ${2}',
            information: {
                cash_title: 'Card Payments:',
                cash_one_time: 'Your max individual reload amount is ${0}',
                cash_per_period: 'Your max overall amount is ${0}',
                cash_period: 'Replenishes every {0} days',
                points_title: 'Point Redemptions:',
                points_one_time: 'Your max individual point conversion is {0}',
                points_per_period: 'Your max overall conversion is {0}',
                points_period: 'Replenishes every {0} days'
            }
        },
        pointsConvertor: {
            title: 'Convert points to cash',
            notEnoughPoints: 'You do not have enough balance',
            pointsFor: 'Points for',
            reloadSuccess: 'Reloaded card successfully',
            selectRoyaltyError: 'Please select loyalty card to proceed',
            form: {
                accountNumber: {
                    placeholder: 'Account Number'
                }
            }
        },
        send: {
            title: 'Send {0} to a friend',
            sent: {
                title: ' {0} sent!',
                amount: 'Amount: ${0}',
                to: ' to:{0}'
            },
            form: {
                email: {
                    title: 'friend\'s email address',
                    error: 'Please enter a valid email address'
                }
            }
        },
        received: {
            disclaimer: 'You received a {0}!',
            title: 'New {0} received',
            button: 'Add to wallet',
            from: 'From: {0}'
        },
        add: {
            title: 'Add a {0}',
            uploadButton: 'Upload existing {0}',
            fundButton: 'Fund your new {0}'
        },
        importExisting: {
            title: 'Import existing {0}',
            form: {
                number: {
                    title: '{0} number*',
                    error: 'Card number is required and should be 19 digits'
                },
                pin: {
                    title: 'pin code*',
                    error: 'Pin code is required and should be 4 digits'
                }
            },
            currentBalance: 'Current balance {0}',
            submitButton: 'Add card to wallet',
            error: 'There was some issue importing your card, please try again later',
            success: 'Imported your card successfully'
        },
        deleteCardsModal: {
            title: 'Clean up',
            description: 'Choosing this option will eliminate unused cards or those with a remaining balance of 0',
            disclaimer: 'You cannot undo this action',
            backButton: 'Back to wallet',
            confirmButton: 'Clean wallet'
        },
        transactions: {
            title: '{0} load history',
            greeting: 'Hello, {0}',
            lastUpdated: 'Last updated {0}',
            noTransactions: 'You do not have any load history',
            back: 'Return to home page',
            nextPage: 'next page',
            prevPage: 'previous page',
            total: 'total {0}',
            pageOf: 'page {0} of {1}',
            view_transaction: 'View load history',
            transaction_points: '{0} points',
            processing_fee: '+ {0} fee',
            card_load: 'Card load',
            empty_state: 'You do not have any load history',
            details: {
                titleLoadAmount: ' Load Amount',
                titleDate: 'Date',
                id: 'Transaction ID: {0}',
                date: 'Transaction date',
                status: 'Transaction status',
                type: 'Transaction type',
                nmi: 'Card payment',
                points_for_cash: 'Point conversion',
                offer_extension: 'Offer extension',
                referenceId: 'Transaction reference id',
                fee: 'Transaction fee',
                total: 'Transaction total',
                currency: 'Transaction currency',
                last4digit: 'Payment last 4 digits',
                providerId: 'Payment provider id',
                loadAmount: 'Card load amount',
                pointsRedeemed: 'Points redeemed',
                giftCardDigits: 'Card last 4 digits',
                reward: 'Offer extension',
                card_holder_name: 'Card holder name',
                customer_authorization: 'Customer authorization',
                confirmed: 'Confirmed'
            }
        }
    },
    suspended_account: {
        disclaimer: 'Valued customer, we appreciate your loyalty. We are in the process of renewing our loyalty program agreement. While we work out the details of this renewal, we wanted to assure you that the points' + ' and rewards that you have earned with us are 100% safe and sound. Access to your loyalty wallet will be made available as soon as possible. We apologize for any inconvenience that this may be causing.' + ' Feel free to reach out to our team at the store if you have any questions and/or concerns.'
    },
    shop: {
        title: 'Shop',
        filters: 'Apply filters',
        apply_filters: 'Apply filters',
        active_filters: 'Active filters',
        clear_filters: 'Clear',
        between_price_filter: 'Between ${0} and ${1}',
        sort: 'Sort by:',
        in: 'in',
        favorite_brands: 'Favorite brands',
        search: 'Search',
        see_all: 'See all',
        cart_empty: 'Your cart is empty',
        apply: 'Apply',
        oops: 'Oops!',
        we_cant_find: 'We can\'t find your previous orders.',
        add_your_email: 'Add your email here to see your previous orders',
        add_email: 'Add email',
        x: 'x',
        subtotal: 'Subtotal:',
        fees: 'Fees:',
        taxes: 'Taxes:',
        discounts: 'Discounts:',
        total: 'Total:',
        back: 'Back',
        order_number: 'Order number:',
        order_submitted: 'Order submitted!',
        return_to_app: 'Return to app',
        at: 'at',
        delivery: 'Delivery',
        pickup: 'Pickup',
        items: 'Items',
        see_past_orders: 'See past orders',
        go_to_checkout: 'Go to checkout',
        back_to_store: 'Back to store',
        see_fulfillment_hours: 'See fulfillment hours',
        some_fulfillment_options: '* some fulfillment options might not be available due to ordering hours -',
        would_you_like_to_continue: 'Would you like to continue?',
        due_to_differences: 'Due to differences in inventory and pricing, changing your location you will lose all order progress.',
        directions: 'Directions',
        call: 'Call',
        view_cart: 'View cart',
        add_to_cart: 'Add to cart',
        add: 'Add',
        thc: 'thc: ',
        cbd: 'cdb: ',
        add_item: 'Add item',
        view_details: 'View details',
        reorder: 'Reorder',
        item: 'Item',
        s: 's',
        grant_permission: 'Grant permission',
        grant_permission_info: 'Location permissions are required in order to shop online',
        your_orders: 'Your orders',
        pick_your_location: 'Pick your location',
        location_and_method: 'Location and method',
        no_matching_location: 'No store matching your search parameter',
        distance: 'Distance',
        update_your_email: 'Update your email information',
        grant_location_permission: 'Grant location permission',
        location_permissions_are_required: 'Location permissions are required in order to shop online',
        permissions_can_be_reset: 'Permissions can be reset in your preferences or by clicking the icon in the address bar',
        alert: 'Alert'
    },
    payment: {
        manage: 'Manage',
        manage_payments: 'Manage payments',
        cards_on_file: 'Cards on file',
        new_card: '+ new card',
        add: 'Add',
        remove: 'Remove',
        save: 'Save'
    },
    native_app_subscriptions: {
        change_card_page: {
            card_updated: 'card successfully update',
            title: 'Update Card Information'
        },
        email_verification_page: {
            email_updated: 'email successfully updated',
            title: 'Update Billing Email Address'
        },
        manage_subscriptions_page: {
            change_card: 'Change Card',
            update_email: 'Update Billing Email Address',
            cancel_subscription: 'Cancel Subscription',
            subscription_cancelled: 'Subscription successfully cancelled',
            cancel_subscription_modal: {
                title: 'Cancel Subscription',
                body: 'Are you sure you would like to cancel your {0} subscription and miss out on exclusive offers?',
                button_cancel: 'Cancel subscription',
                button_no: 'No'
            },
            plan_renews: 'Plan renews {0}'
        },
        subscriptions_page: {
            message_sent: 'Message sent',
            an_email: 'An email was sent to {0}',
            check_your_email: 'Check your email inbox for more information',
            change_email_button: 'Change email address',
            close_button: 'Close',
            send_me_an_email: 'Send me an email with more info',
            click_here_to_signup: 'Click here to learn more via email',
            or: 'or',
            visit_link: 'Visit {0}',
            copy_url: 'Copy URL',
            success_message: 'URL copied to clipboard',
            current_plan: {
                title: 'My Plans',
                benefits_include: 'Benefits include:',
                manage: 'Manage',
                plan: 'Plan',
                active_until: 'Active until {0}',
                plan_renews: 'Plan renews {0}',
                intrested_in: 'Interested in other plans?',
                click: 'Click the button below for more information'
            },
            enter_email: {
                title: 'Enter your email address',
                body: 'We don\'t seem to have your email address on file. Provide your email address below in order to sign up for subscriptions'
            },
            subscription_plan: {
                title: 'How do I become a premium member?',
                body_1: 'Members that sign up to the {0} premium plan will unlock exclusive offers and benefits.',
                body_2: 'Small price. Big discounts! Cancel at anytime',
                body_3: 'Sign up today! No reason to wait'
            }
        },
        headers: {
            manage: 'Manage Plan',
            change_card: 'Change Card',
            email: 'Billing Email Address'
        }
    },
    home_page: {
        named_greetings: 'Hello, ',
        anonymous_greetings: 'Hello!',
        edit: 'Edit',
        save: 'Save',
        view_more: 'See more',
        filters: {
            total: 'Total',
            week: 'Last 7 days'
        },
        subscriptions: {
            title: 'Subscriptions',
            benefits: 'Benefits',
            see_benefits: 'See benefits'
        },
        gift_cards: {
            title: '{0}',
            manage_funds: 'Manage funds',
            // eslint-disable-next-line max-lines
            view_all: 'View all cards',
            view_barcode: 'View barcodes',
            card_balance: '${0} card balance',
            back: 'Back'
        },
        milestones: {
            title: 'Milestones',
            spend_title: 'Spend milestones',
            points_title: 'Points milestones'
        },
        referrals: {
            title: 'Refer a friend',
            copy_link: 'Copy link',
            copied_link: 'Copied link',
            offers_earned: 'Offers earned',
            referred: 'Referred'
        },
        messages: {
            title: 'Messages',
            unread: 'Unread',
            caught_up: 'You\'re all caught up!',
            previous: 'See previous'
        },
        rewards: {
            title: 'Rewards',
            earned: 'Earned',
            redeemed: 'Redeemed',
            highest: 'Highest available',
            get: 'Get',
            value: '{0} points'
        },
        offers: {
            title: 'Offers',
            earned: 'Earned',
            redeemed: 'Redeemed',
            latest: 'Latest',
            get: 'Get',
            expiration: 'exp {0}',
            redemptions: 'use x{0}'
        },
        bonus_points: {
            title: 'Bonus points'
        },
        point_balance: {
            title: 'Point balance',
            learn_more: 'Learn how to earn more points',
            total_points: 'Total points',
            last_earned: 'Last earned',
            bonus_points: {
                title: 'Bonus points',
                get: 'use x{0}',
                unlimited: 'Get',
                earning: 'Earning',
                earning_prefix_multiplication: 'Earn x{0} points',
                earning_prefix_addition: 'Earn {0} points',
                expiration: 'exp {0}'
            },
            and: 'and',
            or: 'or',
            bonus_rules: {
                day_of_the_week: 'on {0}',
                order_source: 'when you order {0}',
                transaction_location: 'when you shop at {0}',
                time_of_day_range: 'between {0} and {1}',
                points_earned_range: 'when you spend between {0} and {1} points',
                transaction_total_range: 'when you spend between ${0} and ${1}',
                earning_prefix_multiplication: 'earn x{0} points',
                sku_purchased: 'when you purchase {0}',
                product_purchased: 'when you purchase {0}',
                brand_purchased: 'when you purchase {0} products'
            },
            week_days: {
                0: 'sundays',
                1: 'mondays',
                2: 'tuesdays',
                3: 'wednesdays',
                4: 'thursdays',
                5: 'fridays',
                6: 'saturdays'
            },
            locations: {
                instore: 'in store',
                ecommerce_delivery: 'through e-commerce delivery',
                ecommerce_pickup: 'through e-commerce pick-up',
                ecommerce: 'through e-commerce'
            }
        }
    },
    homepage: {
        alerts: 'Alerts',
        edit: 'Edit',
        save: 'Save',
        plan: 'Plan:',
        welcomeBack: 'Welcome back, {0}',
        pointsAvailable: 'You have {0} points available to redeem!',
        learnMore: 'Learn how to earn more points',
        viewRewards: 'View Rewards',
        viewOffers: 'View Offers ({0})',
        giftCard: {
            hide: 'Hide',
            show: 'Show',
            pin: 'PIN',
            balance: 'Balance',
            manageFunds: 'Manage funds',
            viewBarcode: 'View barcode',
            back: 'Back'
        },
        messages: {
            checkLatest: 'Check Your Latest Messages',
            viewAll: 'View all',
            sentAt: 'Sent on {time} ({ago})',
            viewMessage: 'View message'
        },
        milestones: {
            achieved: 'Milestone achieved',
            benefitsInclude: 'Benefits include',
            allAchieved: 'All milestones have been achieved',
            spendMore: 'Spend ${0} more to unlock the next milestone'
        },
        offers: {
            noOffers: 'No Offers Available Right Now',
            offersAvailable: 'Offers are Available to Redeem!',
            viewAll: 'View all',
            stayTuned: 'Stay Tuned for Exclusive Offers!',
            checkBack: 'Check back soon for special discounts and promotions! Shopping regularly boosts your chances of receiving special deals.',
            redeem: 'Redeem',
            unlimited: 'unlimited',
            timesUse: '{0}x use',
            expires: 'Offer Expires:',
            desirableAction: '{0} {1}'
        },
        referrals: {
            title: 'Refer a Friend and Earn Discounts!',
            friendsReferred: 'Friends Referred',
            linkCopied: 'Link copied',
            copiedLink: 'Referral link copied!',
            description: 'Copy and share the referral link below with your friends or show your friends your unique QR code above for an easy sign up',
            copyReferralLink: 'Copy referral link'
        },
        rewards: {
            title: 'Redeem Your Rewards Now!',
            viewAll: 'View all',
            noRewards: 'No Rewards Available Yet, Let\'s Change That!',
            pointsStatus: 'You have {0} points. Just {1} more to redeem a reward!',
            redeem: 'Redeem'
        },
        subscriptions: {
            title: 'Premium Benefits Available',
            viewAll: 'View all',
            premiumMember: 'Premium Member',
            managePlan: 'Manage plan',
            planRenews: 'Plan renews {0}',
            howToBecome: 'How do I become a premium member?',
            benefitsDescription: 'Members that sign up to the {0} premium plan will unlock exclusive offers and benefits!',
            seeMore: 'See more'
        }
    }
};
const _default = lang;
